import { render, staticRenderFns } from "./passrecover.vue?vue&type=template&id=6eb331de"
import script from "./passrecover.vue?vue&type=script&lang=js"
export * from "./passrecover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports